export default __webpack_public_path__ + "static/media/Poppins-Thin.7a596863.ttf";